import React from 'react';
import { motion } from 'framer-motion';
import { Star, User } from 'lucide-react';
const reviews = [{
  name: 'Marek W.',
  role: 'Trener piłki nożnej — Warszawa',
  quote: 'W końcu coś co działa w praktyce. Już w pierwszym tygodniu znalazłem 3 błędy w swojej metodyce których wcześniej nie widziałem.',
  color: 'bg-blue-500'
}, {
  name: 'Tomasz K.',
  role: 'Trener piłki nożnej — Kraków',
  quote: 'Skróciłem czas przygotowania o 80% w pierwszym miesiącu. Nie wierzyłem że PDF może tyle zmienić.',
  color: 'bg-green-500'
}, {
  name: 'Rafał B.',
  role: 'Trener piłki nożnej — Poznań',
  quote: 'W końcu uwolniłem się od wymyślania planu na nowo każdego tygodnia. Ten system naprawdę działa.',
  color: 'bg-purple-500'
}];
export function TopReviews() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-269">
      <div className="max-w-6xl mx-auto" data-id="element-270">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-271">
          Ponad 1 200 trenerów nam zaufało
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-272">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-lg flex flex-col h-full" data-id="element-273">
              <div className="flex items-start gap-4 mb-4" data-id="element-274">
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full ${review.color} flex items-center justify-center flex-shrink-0`} data-id="element-275">
                  <User className="w-5 h-5 md:w-6 md:h-6 text-white" data-id="element-276" />
                </div>
                <div data-id="element-277">
                  <h3 className="font-bold text-navy-primary text-sm md:text-base" data-id="element-278">
                    {review.name}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600" data-id="element-279">
                    {review.role}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-3" data-id="element-280">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-accent text-gold-accent" data-id="element-281" />)}
              </div>

              <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow" data-id="element-282">
                "{review.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}